module.exports = __webpack_public_path__ + "static/media/colicoli13.3512c327.webp";